export default "__VITE_ASSET__XJXxEkgd__"